import { chakra } from '@chakra-ui/react'
import { Option } from '@verbit-ai/verbit-ui-library'

import { shouldForwardProp } from 'src/utils/should-forward-prop'

export const Row = chakra('div', {
    baseStyle: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
    },
})

export const Column = chakra('div', {
    baseStyle: {
        flex: 1,
    },
})

export const Label = chakra('label', {
    baseStyle: ({ theme }) => ({
        fontSize: '14px',
        lineHeight: '21px',
        display: 'block',
        color: theme.palette.verbitModal.textColor,
        marginBottom: '4px',
    }),
})

type ColorIndicatorProps = { $indicatorColor: string; $withShadow?: boolean }
export const ColorIndicator = chakra<'span', ColorIndicatorProps>('span', {
    baseStyle: ({ $withShadow, $indicatorColor, theme }) => ({
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.verbitSelect.checkIconColor}`,
        _before: {
            display: 'inline-block',
            content: '""',
            backgroundColor: $indicatorColor,
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            boxShadow: $withShadow ? '0px 0px 2px rgba(0, 0, 0, 0.75)' : 'unset',
        },
    }),
    shouldForwardProp,
})

export const StyledOption = chakra(Option, {
    baseStyle: {
        [`&[aria-selected='false'] span`]: {
            border: 'none',
        },
    },
})
